import React from 'react'

import { CroppedImage } from '../../cmsTypes'

export const CmsImage: React.FC<{ image: CroppedImage; class?: string; containerClass?: string }> = props => {
    const { image } = props
    if (!image) return null

    const desktop = image.desktop ?? image.tablet ?? image.mobile

    return (
        <picture className={props.containerClass}>
            {image.mobile && <source media="(max-width:767px)" srcSet={image.mobile} />}
            {image.tablet && <source media="(max-width:1023px)" srcSet={image.tablet} />}

            <img className={props.class} src={desktop} />
        </picture>
    )
}
